import { Injectable } from "@angular/core";
import { NpPathResolver } from "@newpla/common";

@Injectable()
export class AppPathResolver extends NpPathResolver {
    LOGIN_PATH: string = '/login';
    FORBIDDEN_PATH: string = '/error/403';
}